import { Component } from '@angular/core';
import { MenuStateService } from '../../../services/menu-state.service';

@Component({
  selector: 'app-mobile-servicios',
  standalone: false,
  templateUrl: './mobile-servicios.component.html',
  styleUrl: './mobile-servicios.component.css'
})
export class MobileServiciosComponent {
  constructor(private menuStateService: MenuStateService){
  }
  cerrarMenu(): void {
    this.menuStateService.toggleMenu(false);
  }
}
